import React from "react";
import { setDropzoneRef } from "@lib/dropzoneRef";
import { useFinancialDocumentUpload } from "./useFinancialDocumentUpload";
import { FinancialDocumentUploadContextValue } from "./financialDocumentUploadContext";

interface Props {
    render: (
        open: FinancialDocumentUploadContextValue["open"],
    ) => React.ReactNode;
}

export const FinancialDocumentsUpload: React.FC<Props> = ({ render }) => {
    const { open, inputProps } = useFinancialDocumentUpload();

    return (
        <>
            {render(open)}
            <input
                {...inputProps}
                className="d-none"
                data-testid="financial-documents-upload-input"
                ref={(el) => setDropzoneRef(inputProps, el)}
            />
        </>
    );
};
